import { getSyntaxHighlighter } from "../app/Common/Highlight/SyntaxHighlighter";

const LANGUAGE_ALIASES: Record<string, string> = {
    js: "javascript",
};

export async function initSyntaxHighlighting(): Promise<void> {
    const blocks = document.querySelectorAll<HTMLElement>("pre code[class*=\"language-\"]");

    if(!blocks.length) {
        return;
    }

    const highlighter = await getSyntaxHighlighter();

    blocks.forEach(block => {
        const match = /language-(\S+)/.exec(block.className);
        const pre = block.parentElement;

        if(!match || !pre) {
            return;
        }

        const lang = LANGUAGE_ALIASES[match[1]] ?? match[1];

        try {
            pre.outerHTML = highlighter.codeToHtml(block.textContent ?? "", {
                lang,
                theme: "github-dark-dimmed",
            });
        } catch {
            // Language isn't registered - leave the block as plain, readable text.
        }
    });
}
